import React from 'react';

import { initialiseLiveChat, destroyLiveChat } from 'ts/services/liveChatService';

export const LiveChat: React.FC<{}> = ({}) => {
  React.useEffect(() => {
    showLiveChat();
    return hideLiveChat;
  }, []);
  return null;
};

const showLiveChat = () => {
  initialiseLiveChat();
};

const hideLiveChat = () => {
  destroyLiveChat();
};
